<form [formGroup]="formGroup" class="inviteUserForm" *ngIf="isInviteUser">
    <div class="row">
        <div class="col-6">
            <lsq-input
                formControlName="contactFirstName"
                [name]="'first-name'"
                label="Contact First Name*"
                i18n-label="First Name input"
                [group]="formGroup"
            >
            </lsq-input>
        </div>
        <div class="col-6">
            <lsq-input
                formControlName="contactLastName"
                [name]="'last-name'"
                label="Contact Last Name*"
                i18n-label="Last Name input"
                [group]="formGroup"
            >
            </lsq-input>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <lsq-input
                formControlName="contactEmail"
                [name]="'email-address'"
                label="Contact Email*"
                i18n-label="Email input"
                [group]="formGroup"
            >
            </lsq-input>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <lsq-phone-input
                formControlName="phoneNumber"
                [name]="'phone-number'"
                label="Phone Number"
                [group]="formGroup"
                [hasInnerLabel]="true"
            >
            </lsq-phone-input>
        </div>
    </div>
</form>
